import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';

function ExpectedParticipantSection({ selectedSectors, handleSectorsChange }) {
  const [sectors, setSectors] = useState([]);
  const [isSectorLoading, setIsSectorLoading] = useState(false);
  useEffect(() => {
    const getSector = async () => {
      try {
        setIsSectorLoading(true);
        const response = await fetchWrapper.get('/sector/');
        const sectorData = response.data.results;
        setIsSectorLoading(false);
        setSectors(sectorData.sort((a, b) => a.id - b.id));
      } catch (error) {
        ErrorMessageHandler(error);
        setIsSectorLoading(false);
      }
    };
    getSector();
  }, []);
  return (
    <div onChange={handleSectorsChange}>
      {isSectorLoading
        ? 'loading'
        : sectors.map((sector) => {
            return sector.sector_childrens.map((secChild) => {
              let isChecked = false;
              selectedSectors.forEach((selected) => {
                if (secChild.id === selected?.id) {
                  isChecked = true;
                }
              });
              return (
                <Form.Check
                  key={`${secChild.id}-sector}`}
                  id={`${secChild.id}-sector`}
                  type="checkbox"
                  label={`${secChild.title} (${sector.title})`}
                  defaultChecked={isChecked}
                  data-sector={JSON.stringify({
                    id: secChild.id,
                    title: `${secChild.title} (${sector.title})`
                  })}
                />
              );
            });
          })}
    </div>
  );
}

export default ExpectedParticipantSection;
